import { useSelector } from 'react-redux'; // @ts-expect-error module is untyped

import { selectPortalScopes } from '../selectors/auth';
export function useMissingPortalScopes(requiredScopes) {
  const portalScopes = useSelector(selectPortalScopes);
  if (!requiredScopes) return [];
  const missingPortalScopes = requiredScopes.filter(scope => !portalScopes.includes(scope));
  return missingPortalScopes;
}